/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Unit of work
 * @export
 */
export const WorkedUnit = {
    Day: 'DAY',
    Hour: 'HOUR'
} as const;
export type WorkedUnit = typeof WorkedUnit[keyof typeof WorkedUnit];


export function instanceOfWorkedUnit(value: any): boolean {
    for (const key in WorkedUnit) {
        if (Object.prototype.hasOwnProperty.call(WorkedUnit, key)) {
            // @ts-ignore
            if (WorkedUnit[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WorkedUnitFromJSON(json: any): WorkedUnit {
    return WorkedUnitFromJSONTyped(json, false);
}

export function WorkedUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkedUnit {
    return json as WorkedUnit;
}

export function WorkedUnitToJSON(value?: WorkedUnit | null): any {
    return value as any;
}

